/**
 * Common Switch Props
 */
export var switchProps = {
  value: null,
  loading: Boolean,
  disabled: Boolean,
  activeColor: String,
  inactiveColor: String,
  activeValue: {
    type: null,
    "default": true
  },
  inactiveValue: {
    type: null,
    "default": false
  },
  size: {
    type: String,
    "default": '30px'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/switch/shared.js
// module id = null
// module chunks = 